import { observer } from 'mobx-react';
import { SEARCH_CATEGORIES } from '../../../../utils/constants/searchCategories';
import { SEARCH_FIELDS } from '../../../../utils/constants/fields';

const SearchFormMobile = observer(
  ({ onShowSection = null, fields, fieldsCount, isTypeSelected, isSearchDisabled, onSearch }) => {
    const onSetSection = (section) => {
      if (onShowSection) {
        onShowSection(section);
      }
    };

    return (
      <form className="mobile" onSubmit={onSearch}>
        {fields[SEARCH_FIELDS.SEARCH_TYPE.ID]}
        {Object.values(SEARCH_CATEGORIES).map((section) => {
          const { filled, total } = fieldsCount[section];
          return (
            <button
              className="btn btn-next"
              key={section}
              onClick={() => onSetSection(section)}
              disabled={!isTypeSelected}>
              {section} {filled}/{total}
            </button>
          );
        })}
        <button type="submit" className="btn btn-primary" disabled={isSearchDisabled}>
          Search
        </button>
      </form>
    );
  }
);

export default SearchFormMobile;
